import styled from "styled-components"
import { ReactComponent as User } from "images/icons/circle-user-solid.svg"
import { ReactComponent as Edit } from "images/icons/circle-ellipsis.svg"
import SecondaryButton from "../../Ui/Buttons/SecondaryButton"

type StyledProps = {
  $editDisabled: boolean
  $showEdit?: boolean
}

type ExpandedProps = {
  $expanded?: boolean
}

export const MoreOrderButton = styled(SecondaryButton)`
  font-size: 1.1rem;
  align-self: flex-end;
`

export const Container = styled.div<StyledProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    flex-direction: row;
  }
`

export const Customer = styled.div`
  display: flex;

`

export const ActionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ActionButton = styled(SecondaryButton)`
  font-size: 1.1rem;
  margin-right: 1rem;
  padding: 1rem;
  margin-top: 2rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    margin-top: 0;
  }
`

export const UserIcon = styled(User)`
  height: 6.8rem;
  margin-right: 2rem;
  fill: ${({ theme }) => theme.colors.greyLight};
`

export const EditIcon = styled(Edit)<StyledProps>`
  height: 3.2rem;
  right: 0;
  fill: ${({ theme }) => theme.colors.grey};
  cursor: ${(p) => (p.$editDisabled || !p.$showEdit ? "default" : "pointer")};
  background: ${(p) => p.theme.colors.white};
  border-radius: 50%;

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: ${(p) => (p.$editDisabled ? "default" : "pointer")};
    fill: ${({ theme, $editDisabled }) =>
      $editDisabled ? theme.colors.grey : theme.colors.greyLight};
  }
`

export const Name = styled.h1`
  margin: 0;
  font-size: 2.4rem;
`

export const Contacts = styled.div`
  color: ${({ theme }) => theme.colors.greyDark};
  line-height: 1.6rem;
  margin-top: 0.5rem;
`

export const Email = styled.div`
  display: flex;
  align-items: center;
`

export const Unsaved = styled.div`
  background-color: ${({ theme }) => theme.colors.turquoiseDark};
  height: 3rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    background-color: ${({ theme }) => theme.colors.turquoiseDarker};
    cursor: pointer;
  }
`

export const IconWrapper = styled.div<ExpandedProps>`
  display: flex;
  justify-content: flex-end;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  margin: ${(p) => (p.$expanded ? "2rem 0" : "2rem 0 0 9rem")};
  padding-top: 1rem;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.greyDarker};

    &:hover {
      fill: ${({ theme }) => theme.colors.greyDark};
    }
  }

  svg {
    height: 1.8rem;
    margin-left: 0.8rem;
    fill: ${({ theme }) => theme.colors.greyDarker};

    &:hover {
      fill: ${({ theme }) => theme.colors.greyDark};
    }
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
